import { get } from "../base.ehq.model";
import { deserialize } from "../base.serializer";

export const getActivities = async (
  token: string,
  baseUrl: string,
  params = {}
) => {
  try {
    const queryPath = `${baseUrl}/activities`;

    const res = await get(token, queryPath, params);
    const deserializedRes = await deserialize(res);

    return {
      meta: res.meta,
      activities: deserializedRes
    };
  } catch (err) {
    throw new Error(err);
  }
};
